import React from 'react'
import { Link } from 'react-router-dom'
import {
  memberships,
  startingSwing,
  venue,
  wednesdayNightSwing,
} from '../content/classes'
import {
  Detail,
  LocationDetail,
  SignupCard,
} from '../components/Class/ClassPageParts'
import { NewZealandTestimonial } from 'app/layout/Testimonial'
import { PageHeading } from 'app/layout/PageHeading'

export const WednesdayNightSwingPage = () => (
  <article>
    <PageHeading
      title='Wednesday Night Swing'
      kicker={`${wednesdayNightSwing.day}, ${wednesdayNightSwing.time}`}
      description={wednesdayNightSwing.headline}
      image='stlswing/wednesday-night-swing.jpg'
      position='50% 20%'
      size='tall'
    />

    <div className='flex flex-col max-w-6xl px-4 py-10 mx-auto sm:px-6 md:py-16 lg:grid lg:grid-cols-12 lg:gap-16'>
      <div className='order-2 mt-12 lg:mt-0 lg:order-1 lg:col-span-7'>
        <section>
          <h2 className='h2'>A night of dancing</h2>
          <p className='mt-6 body'>{wednesdayNightSwing.description}</p>
        </section>

        <section className='p-6 mt-12 bg-white rounded-3xl md:p-8'>
          <h2 className='h3'>Never danced before?</h2>
          <p className='mt-2 body'>
            Take Starting Swing at 7:30 PM, right before the dance.{' '}
            {startingSwing.nextSeriesText}, and every class includes the dance
            as part of its price.
          </p>
          <Link to='/starting-swing' className='inline-block mt-3 link'>
            See Starting Swing
          </Link>
        </section>

        <section className='mt-16'>
          <h2 className='h2'>Details</h2>
          <dl className='mt-6 border-b border-rule'>
            <Detail label='When'>
              {wednesdayNightSwing.day}, {wednesdayNightSwing.time}
            </Detail>
            <Detail label='Who'>
              Everyone. Come to dance, to watch, or to listen to the music.
            </Detail>
            <Detail label='Partner'>No partner required.</Detail>
            <Detail label='Price'>
              <p>
                {wednesdayNightSwing.price} on its own. Every class we teach
                includes the dance as part of its price.
              </p>
              <p>
                Here most weeks? The {memberships.socialOnly.name} membership is{' '}
                {memberships.socialOnly.price}.{' '}
                <a href={memberships.url} className='link'>
                  See memberships
                </a>
              </p>
            </Detail>
            <LocationDetail />
          </dl>
        </section>
      </div>

      <div className='order-1 lg:order-2 lg:col-span-5'>
        <SignupCard
          heading={`${wednesdayNightSwing.day}, 8:30 PM`}
          price={wednesdayNightSwing.price}
          priceNote='per dance'
          facts={[
            wednesdayNightSwing.time,
            `${venue.name}, ${venue.neighborhood}`,
            'Included with every class',
          ]}
          href={wednesdayNightSwing.signupUrl}
          buttonText='Get a ticket'
          footnote='Tickets are sold on our Commuvity store.'
        />
      </div>
    </div>

    <NewZealandTestimonial />
  </article>
)

export default WednesdayNightSwingPage
